import {useState, useEffect} from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Container, Typography } from "@mui/material";
import {
    Login,
    CreateProfile,
    CreateKid,
    Dashboard,
    Letters,
    Leaderboard
} from '../screens';
import { Web3Auth } from "@web3auth/web3auth";
import {CHAIN_NAMESPACES} from "@web3auth/base";
import {useNavigate, useSearchParams} from 'react-router-dom';
import { TransitionGroup, CSSTransition } from "react-transition-group";

const Protected = ({children}) => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const accountId = localStorage.getItem('brainsprays-accountId')

    if(accountId)
        return (
            <>
                {children}
            </>
        )
    else
        navigate(`/login?testDoc=${searchParams.get('testDoc')}`)
}

const Rerouter = () => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        const testDoc = searchParams.get('testDoc')
        const accountId = localStorage.getItem('brainsprays-accountId')

        if(accountId) {
            navigate(`/dashboard?testDoc=${testDoc}`)
        }
        else {
            navigate(`/login?testDoc=${testDoc}`)
        }
     }, [])
}

const RootRouter = () => {
    const [web3Auth, setWeb3Auth] = useState(null);
    const [provider, setProvider] = useState(null);

    const init = async () => {
        try {
            const web3auth = new Web3Auth({
                clientId: "BDHdFNUTtovTHMCqVCp5XlyXPjlSdu2wcjBo2e1wcdecflCJsrD_3w8ifoCWJYXIt90DoJrmS4swOZo1zGsQTV0",
                chainConfig: {
                    chainNamespace: CHAIN_NAMESPACES.EIP155,
                    chainId: "0x89",
                },
            });

            setWeb3Auth(web3auth);
            await web3auth.initModal();

            if (web3auth.provider) {
                setProvider(web3auth.provider);
            };
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <Container
            sx={{
                minWidth: '100vw',
                minHeight: '100vh',
                backgroundColor: '#F7F7FF',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                padding: 0,
                margin: 0
            }}
        >
            <TransitionGroup component={null}>
                <CSSTransition key={window.location.pathname} classNames="fade" timeout={300}>
                    <BrowserRouter>
                        <Routes>
                            <Route path='/' element={<Rerouter/>} />
                            <Route path='/login' element={<Login web3Auth={web3Auth} provider={provider} setProvider={setProvider} />} />
                            <Route path='/create-profile' element={<Protected><CreateProfile /></Protected>} />
                            <Route path='/create-kid-profile' element={<Protected><CreateKid /></Protected>} />
                            <Route path='/dashboard' element={<Protected><Dashboard web3Auth={web3Auth} provider={provider} setProvider={setProvider} /></Protected>} />
                            <Route path='/letters/:letter' element={<Protected><Letters /></Protected>} />
                            <Route path='/leaderboard' element={<Leaderboard />} />
                        </Routes>
                    </BrowserRouter>
                </CSSTransition>
            </TransitionGroup>
        </Container>
    )
}

export default RootRouter;